module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-234.fbd7c433.svg";